import { ACTIONS_TRUCK_MODEL } from '../_constants/truckModel.constants';

const initialState = {
  byId: {},
};

export function truckModelReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_TRUCK_MODEL.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_TRUCK_MODEL.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_TRUCK_MODEL.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default truckModelReducer;
